import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import HeroSection from '../Landing/HeroSection';
import InstructionsSection from '../Landing/InstructionsSection';

const LoginPage = () => {
  const { loginWithGoogle, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the redirect path from location state
  const from = location.state?.from || '/dashboard';

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  const handleLogin = async (googleToken) => {
    try {
      await loginWithGoogle(googleToken);
      navigate(from);
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  const handleError = (error) => {
    console.error('Google OAuth error:', error);
  };

  return (
    <Box>
      <HeroSection onLogin={handleLogin} onError={handleError} />
      <InstructionsSection />
    </Box>
  );
};

export default LoginPage;